var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.488,
    height: 16.488,
    viewBox: "0 0 16.488 16.488",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35820",
    "data-name": "Group 35820",
    transform: "translate(-32.862 -452.69)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "info",
    transform: "translate(33.512 453.34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35884",
    "data-name": "Path 35884",
    d: "M7.476,0A7.6,7.6,0,0,1,15.01,9.236a13.774,13.774,0,0,0-.343,2.965v1.93a.535.535,0,0,1-.535.535H12.2a13.773,13.773,0,0,0-2.965.343A7.595,7.595,0,1,1,7.476,0Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35882",
    "data-name": "Path 35882",
    d: "M214.079,274.451a.745.745,0,1,0,.745.745.745.745,0,0,0-.745-.745",
    transform: "translate(-172.973 189.456)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35883",
    "data-name": "Path 35883",
    d: "M171.412,64.1a.745.745,0,0,0,.745-.745.745.745,0,1,1,1.185.6,2.725,2.725,0,0,0-1.185,2.182v.941a.745.745,0,1,0,1.49,0v-.941a1.277,1.277,0,0,1,.576-.981,2.235,2.235,0,1,0-3.556-1.8.745.745,0,0,0,.745.745",
    transform: "translate(-131.796 395.354)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.69144212df055b8520f7252de20192d4.svg";
export { ForwardRef as ReactComponent };